import React from 'react';
import { DeliveryProvider, OrderMethod } from '../../types/constants';
import { IconProps } from './types';
import { ShoppingOutlined, TruckOutlined } from '@ant-design/icons';
import DeliveryProviderIcon from './DeliveryProviderIcon';

type Props = IconProps & {
  orderMethod: OrderMethod;
  deliveryProvider?: null | DeliveryProvider;
};

export default function OrderMethodIcon({ orderMethod, deliveryProvider, ...props }: Props) {
  if (orderMethod === OrderMethod.Delivery && deliveryProvider !== DeliveryProvider.Standalone) {
    return <DeliveryProviderIcon provider={deliveryProvider} {...props} />;
  }

  return (
    {
      [OrderMethod.Pickup]: <ShoppingOutlined {...props} />,
      [OrderMethod.Delivery]: <TruckOutlined {...props} />,
    }[orderMethod] ?? null
  );
}
